import type { NotebookView } from '../schemas/note-types'

/** Human labels for the notebook's rail tabs and header mode selector.
 *  Storage keys (`feed`, `notes`) predate the labels and stay as they are. */
export const VIEW_LABEL: Record<NotebookView, string> = {
  feed: 'Thought Tracker',
  notes: 'Journal',
  planner: 'Trade Planner',
  tickers: 'Tickers',
  review: 'Review',
  performance: 'Review',
}

/** The five selectable modes, in rail order. */
export const MODE_OPTIONS: ReadonlyArray<{ value: NotebookView; label: string }> = [
  { value: 'feed', label: VIEW_LABEL.feed },
  { value: 'notes', label: VIEW_LABEL.notes },
  { value: 'planner', label: VIEW_LABEL.planner },
  { value: 'tickers', label: VIEW_LABEL.tickers },
  { value: 'review', label: VIEW_LABEL.review },
]
